<template>
  <div class="engineer-box">
    <div class="center-container">
      <div class="center-content">
        <div class="table-top">
          <el-button class="new-btn" @click="newOrder">
            <i class="el-icon-plus"></i>
            <span>创建</span>
          </el-button>
          <el-input
            class="search-input"
            placeholder="请输入搜索内容"
            v-model="search_name"
            prefix-icon="el-icon-search" @keyup.enter.native="searchName">
          </el-input>
        </div>
        <el-table
          :data="tableData"
          class="table-container"
          :header-cell-style="getRowClass"
          :row-class-name="rowClass"
          v-loading="loading"
          border>
          <template slot="empty">
            <img class="empty" src="~assets/icon_none.png" alt="">
            <span class="empty-txt">{{empty}}</span>
          </template>
          <el-table-column
            prop="lab_order_id"
            label="订单号" width=80>
          </el-table-column>
          <el-table-column
            prop="company_name"
            label="公司名称">
          </el-table-column>
          <el-table-column
            prop="total"
            label="总价" width=80>
          </el-table-column>
          <el-table-column
            prop="create_date"
            label="订单时间" width=140>
          </el-table-column>
          <el-table-column
            prop="days"
            label="期限" width=50>
          </el-table-column>
          <el-table-column
            prop="amount"
            label="数量" width=50>
          </el-table-column>
          <el-table-column label="操作" width=300>
            <template slot-scope="scope">
              <el-button
                size="mini" class="detail-btn" @click="handleSeeDetail(scope.row)"><span>详情</span></el-button>
              <el-button size="mini" class="delete-btn" v-if="scope.row.status == 0 && scope.row.type == 0" @click="handleDelete(scope.row, scope.$index)">
                <span>删除</span>
              </el-button>
              <el-button size="mini" class="detail-btn" @click="editOrderInfo(scope.row)">
                <span>备注</span>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-container">
          <el-pagination
            background
            layout = "total, prev, pager, next"
            v-if="total>0"
            :page-size="limit"
            :total = "total"
            :current-page = "page"
            @current-change = "currentPageFun"
            >
          </el-pagination>
        </div>
      </div>
    </div>
    <search-company v-if="newOrderShow" @closeorder="close"></search-company>
    <!-- 删除的弹窗框 start -->
    <delete-box @delete="deleteData" v-if="deleteShow"></delete-box>
    <!-- 删除的弹出框 end -->
    <order-memo :order_info="order_info" @before-close="memoClose" :order_show="order_show" :sales="sales" @updated="updatedMemo"></order-memo>
  </div>
</template>

<script type='text/ecmascript-6'>
import SearchCompany from 'components/SearchCompany.vue'
import DeleteBox from 'components/DeleteBox.vue'
import OrderMemo from 'components/OrderMemo.vue'
import { getStore, setStore, removeStore } from 'common/js/mUtils.js'
export default {
  data () {
    return {
      empty: '没有未完成委托单',
      tableData: [],
      page: 1,
      limit: 10,
      total: 0,
      search_name: '',
      newOrderShow: false,
      deleteShow: false,
      deleteRow: {},
      deleteIndex: 0,
      search_show: false,
      order_show: false,
      sales: [],
      user_type: 0,
      order_info: {lab_order_id:0}
    }
  },
  beforeCreate () { // 在创建实例之前 先 加载 加载框
    this.loading = true
  },
  created () {
    this.user_type = getStore('user_type')
    let order_state_json = getStore('order-state')
    removeStore('order-state')
    if (order_state_json != null) {
      let order_state = JSON.parse(order_state_json)
      if (order_state.state == 1) {
        this.page = order_state.page_num
        this.search_name = order_state.search_name
      }
    }
    this.initData()
    //this.getAllSalesman()
  },
  methods: {
    getRowClass({ rowIndex }) { // 设置表格第一行的颜色
      if (rowIndex == 0) {
        return 'background:#ECF0F8'
      } else {
        return ''
      }
    },
    rowClass({row}){
      if (row.type == 1) {
        return 'row-color'
      }
    },
    // 获取未完成的订单列表
    initData () {
      let that = this
      this.$api.searchUnfinishOrder({
        search: that.search_name,
        page_num: (that.page-1) * this.limit
      }).then(res => {
        that.loading = false
        if (res.data.detail.length > 0) {
          that.tableData = res.data.detail
          that.total = Number(res.data.total)
        } else {
          that.tableData = res.data.detail
          that.total = 0
        }
      }).catch(err => {
        that.$message({
          type: 'error',
          message: err,
          customClass: 'msg-position',
          showClose: true
        })
      })
    },
    getAllSalesman() {
      let that = this;
      if (this.user_type == 5) {
        that.$api.getAllSalesman({
          type: 1
        })
          .then(res => {
            if (res.data.length > 0) {
              that.sales = res.data;
            } else {
              that.sales = [];
              that.$message({
                message: "没有市场人员信息，请添加。",
                type: "error",
                customClass: "msg-position",
                showClose: true
              });
            }
          })
          .catch(e => {
            that.$message({
              message: `${e}`,
              type: "error",
              customClass: "msg-position",
              showClose: true
            });
          });
      }
    },
    currentPageFun (page) {  // 点击 页码
      this.page = page
      if (this.search_show) {
        this.searchName()
      } else {
        this.initData()
      }
    },
    newOrder () { // 创建新的订单
      this.newOrderShow = true
    },
    memoClose() {
      this.order_show = false
    },
    editOrderInfo(order_info) {
      this.order_info = order_info
      this.order_show = true
    },
    updatedMemo(order_show) {
      this.order_show = order_show
    },
    searchName () { // 输入名字搜索
      let that = this
      if (!this.search_show) {
        this.search_show = true
        this.page = 1
      }
      if (that.search_name) {
        this.$api.searchUnfinishOrder({
          search: that.search_name,
          page_num: (that.page-1) * this.limit
        }).then(res => {
          if (res.data.detail.length > 0) {
            that.tableData = res.data.detail
            that.total = Number(res.data.total)
          } else {
            that.tableData = []
            that.total = 0
          }
        }).catch(err => {
          that.$message({
            message: err,
            type: 'error',
            customClass: 'msg-position',
            showClose: true
          })
        })
      } else {
        that.$message({
          type: 'error',
          message: '搜索不能为空！！',
          customClass: 'msg-position',
          showClose: true
        })
      }
    },
    close () { // 监听自定义的
      this.newOrderShow = false
    },
    handleSeeDetail (row) { // 点击详情
      // save state, 0:已完成1:未完成2:历史3:统计
      setStore('order-state',{state:1, page_num:this.page, search_name:this.search_name})
      this.$router.push({
        path: '/orderDetail',
        query: { lab_order_id: row.lab_order_id, type: row.type }
      })
    },
    handleDelete (row, index) { // 点击删除仪器
      let that = this
      that.deleteIndex = index
      that.deleteRow = row
      that.deleteShow = true
    },
    deleteData (val) { // 点击删除的弹出框
      let that = this
      if (val === 'cancle') {
        that.deleteIndex = 0
        that.deleteRow = {}
        that.deleteShow = false
      }
      if (val === 'sure') {
        that.delete(that.deleteIndex, that.deleteRow.lab_order_id)
        that.deleteIndex = 0
        that.deleteRow = {}
        that.deleteShow = false
      }
    },
    delete (index, lab_order_id) { // 点击确认删除
      let that = this
      this.$api.deleteUnfinishOrder({
        lab_order_id: lab_order_id
      }).then(res => {
        if (res.data.msg === true) {
          that.tableData.splice(index, 1)
          that.$message({
            type: 'success',
            message: '删除成功!',
            customClass: 'msg-position',
            showClose: true
          })
        } else {
          that.$message({
            type: 'error',
            message: '删除失败',
            customClass: 'msg-position',
            showClose: true
          })
        }
      })
    }
  },
  watch: {
    /* '$route': 'initData' */
  },
  components: {
    SearchCompany,
    DeleteBox,
    OrderMemo
  }
}
/* 未创建委托单可以查看详情 还有 如果没有发样的 还要显示 发样按钮  但是要是查看详情的话 就要如果还没有要发样的话 就需要修改 仪器还有 给订单添加新的仪器 如果已经发过样的话 就不能把订单给你在修改 */
</script>

<style lang='stylus' rel='stylesheet/stylus'>
@import '~common/stylus/box.styl'
</style>
